'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorSchemes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSyntaxHighlighter = require('react-syntax-highlighter');

var _reactSyntaxHighlighter2 = _interopRequireDefault(_reactSyntaxHighlighter);

var _hljs = require('react-syntax-highlighter/styles/hljs');

var colorSchemes = _interopRequireWildcard(_hljs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 */
var RawCode = function RawCode(props) {
  return _react2.default.createElement(
    _reactSyntaxHighlighter2.default,
    {
      className: props.className,
      language: props.language,
      style: props.style },
    props.children
  );
};

/**
 * @public
 */
var Code = (0, _styledComponents2.default)(RawCode).withConfig({
  displayName: 'code__Code'
})(['font-size:var(--code-font-size,1em);']);

/**
 * @private
 */
RawCode.propTypes = {
  style: _propTypes2.default.object,
  language: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.string.isRequired

  /**
   * @private
   */
};RawCode.defaultProps = {
  style: {},
  language: '',
  className: ''

  /**
   * @private
   */
};Code.propTypes = {
  style: _propTypes2.default.object,
  language: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.string.isRequired

  /**
   * @private
   */
};Code.displayName = 'Code';

exports.colorSchemes = colorSchemes;
exports.default = Code;